import { render, staticRenderFns } from "./DashboardStorageThreshold.vue?vue&type=template&id=3d4d134e&"
import script from "./DashboardStorageThreshold.vue?vue&type=script&lang=js&"
export * from "./DashboardStorageThreshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports